import { styled } from '../../../../lib/stitches'

const Title = styled('h1', {
  fontSize: '32px',
  lineHeight: '42px',
  letterSpacing: '-0.04em',
  fontWeight: '$bold',
  color: 'rgb(0,0,0)',
  margin: 0
})

export default Title
